import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingFullScreenComponent } from '@/components/loading-full-screen/loading-full-screen.component';
import { ErrorHandler } from '@/http/error.interceptor';
import { JwtInterceptor } from '@/http/jwt.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ErrorDialogModule } from './components/error-dialog/error-dialog.module';
import { DialogModule } from './components/dialog/dialog.module';
import { MaterialModule } from './shared/material.module';
import { NgxLoadingModule } from 'ngx-loading';
import { ToastrModule } from 'ngx-toastr';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogOrderModule } from './components/dialogOrder/dialogOrder.module';
import { DialogViabilityModule } from './components/dialogViability/dialogViability.module';
import { DialogStartOperationModule } from './components/dialogStartOperation/dialogStartOperation.module';
import { DialogExclusiveModule } from './components/dialogExclusive/dialogExclusive.module';
import { DialogExportFileModule } from './modules/private/financial/exclusive-promoter/dialog-export-file/dialogStartOperation.module';
import { DialogDateModule } from './components/dialogDate/dialogDate.module';
import { DialogFeasibilityModule } from './modules/private/financial/requests/feasibility-requests/feasibility-requests-dialog/dialogfeasibility.module';
import { DialogBoletoModule } from './components/dialog-boleto/dialog-boleto.module';

registerLocaleData(localePt);
@NgModule({
  declarations: [AppComponent, LoadingFullScreenComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CdkStepperModule,
    CommonModule,
    DialogModule,
    DialogDateModule,
    DialogOrderModule,
    DialogExclusiveModule,
    DialogViabilityModule,
    DialogFeasibilityModule,
    DialogStartOperationModule,
    DialogExportFileModule,
    DialogBoletoModule,
    NgxMaskDirective,
    DragDropModule,
    HttpClientModule,
    NgxMaskPipe,
    ErrorDialogModule,
    MaterialModule,
    MatDialogModule,
    NgxLoadingModule.forRoot({}),
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 15000, // 15 seconds
      progressBar: true,
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandler, multi: true },
    provideNgxMask(),
    provideNativeDateAdapter(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
